import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Spanish from "./Spanish";
import English from "./English";

i18n.use(initReactI18next).init({
  lng: "es", // idioma por defecto
  fallbackLng: "es", // Lenguaje que se cargara en caso de que las traducciones no están disponibles.
  interpolation: {
    // sirve para escapar los valores y evitar ataques XSS, React lo hace por defecto. por eso se dejó en false
    escapeValue: false,
  },
  // traducciones que se usaran en la aplicación.
  resources: {
    es: {
      translation: Spanish,
    },
    en: {
      translation: English,
    },
  },
});

export default i18n;
